import { useEffect, useRef, useState } from "react";
import { Link } from 'react-router-dom';
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall } from "../CommonComponents/CustomHooks";
import config from "../CommonComponents/EnvConfig";
import Loader from "../CommonComponents/Loader";

const ForgotPasswordSlide1 = () => {
    const [user, setUser] = useState({
        userCode: '',
        LoginType: 'Admin'
    });
    const [isLoading, setIsLoading] = useState(false)
    const inputrefs = useRef([]);
    const StaticToken = config.secret_key;

    useEffect(() => {
        document.title = 'Forget Password'
    }, [])

    const HandleChange = (prop, value) => {
        setUser(user => ({ ...user, [prop]: value }))
    }

    const HandleSubmit = async () => {
        setIsLoading(true);
        const data = {
            ...user,
            AuthToken: StaticToken,
            Source: 'web'
        }
        let res = await ApiCall(`/api/Login/ForgetPassword`, data)
        if (res.status === 'SUCCESS') {
            NotificationSound(res.status, res.message, res.focus, inputrefs)
        } else {
            setIsLoading(false);
            NotificationSound(res.status, res.message, res.focus, inputrefs)
        }
        setIsLoading(false)
    };

    return (
        <>
            <section className='login-page'>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-6 col-md-12 px-0">
                            <div className="login-image">
                                <img src="https://portal.cppwebservices.in/Content/Login/img/logo.png?v=2" alt="Logo" />
                                <h3>Welcome to <br />CPP Login Panel</h3>
                                <p className="top">Your one stop platform for</p>
                                <p>CPP Membership</p>
                            </div>
                        </div>
                        <div className="col-lg-6 p-0 col-md-12 d-flex justify-content-between flex-column align-items-center">
                            <div className="aboutSec otpSec">
                                <div className="otpSecLft loginLft">
                                    <div className='ram'>
                                        <h2 className="logTitle">Forgot Password</h2>
                                        <div className="loginpSec mb-10 position-relative">
                                            <label htmlFor="txtUserCode" className="form-label lbl"> User Code</label>
                                            <input
                                                className="form-control txtField username"
                                                id="txtUserCode"
                                                ref={ref => (inputrefs.current['txtUserCode'] = ref)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { inputrefs.current['txtPassword'].focus() };
                                                }}
                                                placeholder='User Code'
                                                maxLength="15"
                                                autoComplete="off"
                                                value={user.userCode}
                                                onChange={(e) => HandleChange('userCode', e.target.value)}
                                            />
                                        </div>
                                        <div className="rmbr-me mt-4">
                                            <Link to='/Admin' className="orSec"><u>Back To Login</u></Link>
                                        </div>
                                        <button
                                            type="button"
                                            ref={ref => (inputrefs.current['btnSub'] = ref)}
                                            id="btnLogin"
                                            className="pageBtn otpBtn btn-login"
                                            onClick={HandleSubmit}
                                        >
                                            Next
                                        </button>
                                    </div>
                                </div>
                                {isLoading && (<Loader />)}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default ForgotPasswordSlide1;